import { storeFrontApiClient } from '../api/apiClient'

const getProductQuantity = async (id) => {
  try {
    const response = await storeFrontApiClient
      .request(
        `
        query getProductById($id: ID!){
          product(id: $id) {
            totalInventory
            availableForSale
          }
        }
      `,
        {
          variables: {
            id,
          },
        }
      )
      .catch((e) => {
        console.log('catch ===', e)
      })

    return response.data.product
  } catch (e) {
    console.error('Error fetching product', e)
  }
}

export default {
  getProductQuantity,
}
